export function setUrlParameter(sParam: string, sValue: string) {
  var sPageURL = window.location.search.substring(1),
    sUrl = window.location.href.split('?')[0],
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=')

    if (sParameterName[0] === sParam) {
      sParameterName[1] === sValue
      return
    }
  }
  if (sPageURL) {
    window.history.pushState('', '', sUrl + '?' + sPageURL + '&' + sParam + '=' + sValue)
  } else {
    window.history.pushState('', '', sUrl + '?' + sParam + '=' + sValue)
  }
}

export function removeUrlParameter(sParam: string) {
  var sPageURL = window.location.search.substring(1),
    sUrl = window.location.href.split('?')[0],
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=')
    if (sParameterName[0] === sParam) {
      sURLVariables.splice(i, sParameterName[0].length)
    }
  }
  var params = sURLVariables.join('&')
  if (params) {
    window.history.pushState('', '', sUrl + '?' + params)
  } else {
    window.history.pushState('', '', sUrl)
  }
}

export function getUrlParameter(sParam: string) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=')

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1])
    }
  }
  return false
}
